import React, { useContext, useEffect, useState } from "react";
import { PayfacContext } from "../../context/payfac/PayfacContext";
import { useNavigate } from "react-router-dom";

export const PayfacsPage = () => {

    const [buscar, setBuscar] = useState('');
    const { payfacs, loadPayfacs, deletePayfac } = useContext(PayfacContext);

    const navigate = useNavigate();

    useEffect(() => {
        loadPayfacs();
    }, []);

    const filteredData = payfacs.filter(payfac => {

        const search = buscar.toLowerCase();

        return (
            payfac.name?.toLowerCase().includes(search) ||
            payfac.regnumber?.toLowerCase().includes(search) ||
            payfac.prefix?.toLowerCase().includes(search)
        );

    });

    const handleEdit = (payfac) => {
        navigate("/payfac", { state: { payfac } });
    };

    const handleDelete = async (id) => {

        const resp = await deletePayfac(id);

        if (resp !== "success") {
            alert(resp);
        }

    };

    const handleNew = () => {
        navigate("/payfac");
    };

    return (

        <div className="container mt-5">

            <div className="row justify-content-end mt-5">

                <div className="col-md-3">

                    <input
                        className="form-control"
                        placeholder="Buscar"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                    />

                </div>

                <div className="col-md-1">

                    <button
                        className="btn btn-success"
                        onClick={handleNew}
                    >
                        Nuevo
                    </button>

                </div>

            </div>

            <br />

            <table className="table table-hover table-striped">

                <thead className="thead-dark">

                    <tr>
                        <th>Prefijo</th>
                        <th>Nombre</th>
                        <th>Registro</th>
                        <th>Identificador Mastercard</th>
                        <th>Identificador Visa</th>
                        <th style={{ textAlign: "center" }}>Acciones</th>
                    </tr>

                </thead>

                <tbody>

                    {
                        filteredData.length > 0
                            ?
                            filteredData.map(payfac => (

                                <tr key={payfac.id}>

                                    <td>{payfac.prefix}</td>
                                    <td>{payfac.name}</td>
                                    <td>{payfac.regnumber}</td>
                                    <td>{payfac.mc_payfac_id}</td>
                                    <td>{payfac.vi_payfac_id}</td>

                                    <td style={{ textAlign: "center" }}>

                                        <button
                                            className="btn btn-primary"
                                            onClick={() => handleEdit(payfac)}
                                        >
                                            <i className="bi bi-pencil"></i>
                                        </button>

                                        <button
                                            className="btn btn-danger"
                                            style={{ marginLeft: '10px' }}
                                            onClick={() => handleDelete(payfac.id)}
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))
                            :
                            <tr>

                                <td colSpan={6} className="text-center">
                                    No existen Payfacs
                                </td>

                            </tr>
                    }

                </tbody>

            </table>

        </div>

    );
};